import React from "react";
import Seo from "../components/common/Seo";

const LegalNotice = () => {
  return (
    <>
      <Seo
        title="Aviso Legal"
        description="Aviso legal de TransXSur, información sobre la titularidad y condiciones de uso del sitio web."
        url="https://www.transxsur.com/aviso-legal"
      />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-display font-bold mb-8 text-[#1e5939]">
          Aviso Legal
        </h1>
        <div className="prose max-w-none text-gray-700 space-y-6">
          <p>
            En cumplimiento con el deber de información recogido en el artículo
            10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de
            la Información y de Comercio Electrónico (LSSI-CE), a continuación
            se detallan los datos identificativos de la empresa titular del
            sitio web <strong>www.transxsur.com</strong>.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            1. Titularidad
          </h2>
          <ul className="list-disc pl-6">
            <li>
              <strong>Denominación social:</strong> Pedro Ernesto Pérez Griñán
            </li>
            <li>
              <strong>NIF/CIF:</strong> Y7423875H
            </li>
            <li>
              <strong>Domicilio social:</strong> La Barca de la Florida, Jerez
              de la Frontera, Cádiz
            </li>
            <li>
              <strong>Correo electrónico:</strong> info@transxsur.com
            </li>
            <li>
              <strong>Teléfono:</strong> +34 643 49 53 51
            </li>
            <li>
              <strong>Datos registrales:</strong> No procede
            </li>
          </ul>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            2. Propiedad intelectual e industrial
          </h2>
          <p>
            Todos los contenidos del sitio web (textos, imágenes, logotipos,
            estructura, etc.) son propiedad de TransXSur o se dispone de los
            derechos necesarios para su uso. Queda prohibida la reproducción,
            distribución o modificación total o parcial sin autorización
            expresa.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            3. Exención de responsabilidad
          </h2>
          <p>
            El titular no se hace responsable de los posibles errores o
            inexactitudes en la información publicada, ni de los daños derivados
            del uso del sitio web. Los enlaces a sitios externos son meramente
            informativos, no asumiendo responsabilidad sobre su contenido.
          </p>

          <h2 className="text-2xl font-semibold mt-6 text-[#1e5939]">
            4. Legislación aplicable y jurisdicción
          </h2>
          <p>
            Las relaciones establecidas entre el titular y el usuario se regirán
            por la normativa española. Para cualquier controversia, las partes
            se someterán a los juzgados y tribunales de [indicar ciudad, ej:
            Jerez de la Frontera], renunciando a cualquier otro fuero que
            pudiera corresponderles.
          </p>
        </div>
      </div>
    </>
  );
};

export default LegalNotice;
